import {effectiveDefaultSmoker,orderSmokers} from './smoker.js';

function activeRows(rows=[]){
  return (Array.isArray(rows)?rows:[]).filter(row=>!row?.archivedAt);
}

export function createSmokehouseDashboardModel({
  profile=null,
  onboarding=null,
  smokers=[],
  thermometers=[],
  woodInventory=[]
}={}){
  const activeSmokers=orderSmokers(smokers);
  const activeThermometers=activeRows(thermometers);
  const activeWood=activeRows(woodInventory).filter(item=>item.available!==false);
  const defaultSmoker=effectiveDefaultSmoker(activeSmokers);

  const onboardingStatus=String(onboarding?.status||'not_started');
  const onboardingNeedsAttention=!['completed','skipped'].includes(onboardingStatus);

  let primaryAction='open_default_smoker';
  if(onboardingNeedsAttention)primaryAction='resume_onboarding';
  else if(activeSmokers.length===0)primaryAction='add_smoker';
  else if(!defaultSmoker)primaryAction='choose_default_smoker';

  return Object.freeze({
    onboarding:Object.freeze({
      status:onboardingStatus,
      currentStep:onboarding?.currentStep||null,
      needsAttention:onboardingNeedsAttention
    }),
    profile:Object.freeze({
      configured:Boolean(profile?.experienceLevel),
      experienceLevel:profile?.experienceLevel||null
    }),
    smokers:Object.freeze({
      count:activeSmokers.length,
      empty:activeSmokers.length===0,
      defaultSmokerId:defaultSmoker?.id||null,
      ids:Object.freeze(activeSmokers.map(item=>item.id)),
      items:Object.freeze(activeSmokers.map(item=>Object.freeze({
        id:item.id,
        name:item.name||'Wędzarnia',
        isDefault:item.id===defaultSmoker?.id
      })))
    }),
    thermometers:Object.freeze({
      count:activeThermometers.length,
      empty:activeThermometers.length===0,
      ids:Object.freeze(activeThermometers.map(item=>item.id)),
      items:Object.freeze(activeThermometers.map(item=>Object.freeze({
        id:item.id,
        name:item.name||'Termometr',
        channelCount:item.channelCount??null
      })))
    }),
    wood:Object.freeze({
      count:activeWood.length,
      empty:activeWood.length===0,
      availableCount:activeWood.length,
      ids:Object.freeze(activeWood.map(item=>item.id)),
      items:Object.freeze(activeWood.map(item=>Object.freeze({
        id:item.id,
        label:item.customName||item.catalogueKey||'Drewno',
        quantity:item.quantity??null,
        quantityUnit:item.quantityUnit??null
      })))
    }),
    primaryAction
  });
}
